import { c as _c } from "react/compiler-runtime";
import wirWunderLogo from 'assets/images/logos/wirwunder_logo_rgb.svg';
import classNames from 'classnames';
import getSafeImageSource from '../../../utils/getSafeImageSource';
import { Button } from '../../../components/Button';
import { type FC, type ReactNode } from 'react';
import BudgetInfo from './BudgetInfo';
import DurationInfo from './DurationInfo';
import FurtherInfo from './FurtherInfo';
import MatchingConditions from './MatchingConditions';
import PostCodeLotteryInfo from './PostCodeLotteryInfo';
import styles from './ModalContent.module.css';
import SleepyCoinsInfo from './SleepyCoinsInfo';
import type { FurtherInfoText } from './FurtherInfo';
import type { MatchingConditionsText } from './MatchingConditions';
import type { PostCodeLotteryInfoText } from './PostCodeLotteryInfo';
import type { SleepyCoinsInfoText } from './SleepyCoinsInfo';
import type { BudgetInfoText } from './BudgetInfo';
import type { DurationInfoText } from './DurationInfo';
import { DefaultImage } from '../../shared';
import Logos from '../Logos';
import type { ISO8601DateTime, MatchingEventCampaignType } from '../types';
const wwLogo = getSafeImageSource(wirWunderLogo);
export type ModalContentText = {
  close: string;
  duration: DurationInfoText;
  budget: BudgetInfoText;
  matchingConditions: MatchingConditionsText;
  furtherInfo: FurtherInfoText;
  sleepyCoins: SleepyCoinsInfoText;
  postCodeLotteryInfo: PostCodeLotteryInfoText;
};
export type ModalContentProps = {
  isWW: boolean;
  campaignType: MatchingEventCampaignType | null | undefined;
  startsAt: ISO8601DateTime | null | undefined;
  endsAt: ISO8601DateTime | null | undefined;
  providedAmountInCents: number;
  maximumMatchingAmountInCents: number | null | undefined;
  actor: string | null | undefined;
  matchingPercentage: number | null | undefined;
  hasOnlyOneProject: boolean;
  usesSleepyCoins: boolean;
  isPostCodeLottery: boolean;
  branchLogo?: string | null | undefined;
  branchName?: string | null | undefined;
  logo?: string | null | undefined;
  onHide: () => void;
  children?: ReactNode;
  text: ModalContentText;
  locale: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Image?: FC<any>;
};
export function ModalContent(t0) {
  const $ = _c(58);
  const {
    isWW,
    campaignType,
    startsAt,
    endsAt,
    providedAmountInCents,
    maximumMatchingAmountInCents,
    actor,
    matchingPercentage,
    hasOnlyOneProject,
    usesSleepyCoins,
    isPostCodeLottery,
    logo,
    branchLogo,
    branchName,
    onHide,
    children,
    text,
    locale,
    Image: t1
  } = t0;
  const Image = t1 === undefined ? DefaultImage : t1;
  const t2 = isWW ? logo || wwLogo : logo;
  const t3 = isWW ? "wirwunder" : "betterplace";
  const t4 = branchName ?? "";
  let t5;
  if ($[0] !== Image || $[1] !== branchLogo || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = <Logos className={styles.logoContainer} logoSrc={t2} logoAlt={t3} logoSecondarySrc={branchLogo} logoSecondaryAlt={t4} height={38} Image={Image} />;
    $[0] = Image;
    $[1] = branchLogo;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== endsAt || $[7] !== locale || $[8] !== startsAt || $[9] !== text.duration) {
    t6 = <DurationInfo startsAt={startsAt} endsAt={endsAt} text={text.duration} locale={locale} />;
    $[6] = endsAt;
    $[7] = locale;
    $[8] = startsAt;
    $[9] = text.duration;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== locale || $[12] !== providedAmountInCents || $[13] !== text.budget) {
    t7 = <BudgetInfo providedAmountInCents={providedAmountInCents} text={text.budget} locale={locale} />;
    $[11] = locale;
    $[12] = providedAmountInCents;
    $[13] = text.budget;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== campaignType || $[16] !== isWW || $[17] !== locale || $[18] !== maximumMatchingAmountInCents || $[19] !== text.matchingConditions) {
    t8 = <MatchingConditions isWW={isWW} campaignType={campaignType} maximumMatchingAmountInCents={maximumMatchingAmountInCents} text={text.matchingConditions} locale={locale} />;
    $[15] = campaignType;
    $[16] = isWW;
    $[17] = locale;
    $[18] = maximumMatchingAmountInCents;
    $[19] = text.matchingConditions;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== actor || $[22] !== campaignType || $[23] !== hasOnlyOneProject || $[24] !== isWW || $[25] !== locale || $[26] !== matchingPercentage || $[27] !== providedAmountInCents || $[28] !== text.furtherInfo) {
    t9 = <FurtherInfo isWW={isWW} campaignType={campaignType} actor={actor} matchingPercentage={matchingPercentage} providedAmountInCents={providedAmountInCents} hasOnlyOneProject={hasOnlyOneProject} text={text.furtherInfo} locale={locale} />;
    $[21] = actor;
    $[22] = campaignType;
    $[23] = hasOnlyOneProject;
    $[24] = isWW;
    $[25] = locale;
    $[26] = matchingPercentage;
    $[27] = providedAmountInCents;
    $[28] = text.furtherInfo;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== text.sleepyCoins || $[31] !== usesSleepyCoins) {
    t10 = usesSleepyCoins && <SleepyCoinsInfo text={text.sleepyCoins} />;
    $[30] = text.sleepyCoins;
    $[31] = usesSleepyCoins;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== isPostCodeLottery || $[34] !== text.postCodeLotteryInfo) {
    t11 = isPostCodeLottery && <PostCodeLotteryInfo text={text.postCodeLotteryInfo} />;
    $[33] = isPostCodeLottery;
    $[34] = text.postCodeLotteryInfo;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== t10 || $[37] !== t11 || $[38] !== t6 || $[39] !== t7 || $[40] !== t8 || $[41] !== t9) {
    t12 = <div>{t6}{t7}{t8}{t9}{t10}{t11}</div>;
    $[36] = t10;
    $[37] = t11;
    $[38] = t6;
    $[39] = t7;
    $[40] = t8;
    $[41] = t9;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  const t13 = children ? styles.multipleButtonsWrapper : styles.singleButtonWrapper;
  let t14;
  if ($[43] !== t13) {
    t14 = classNames(styles.buttonWrapper, t13);
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  const t15 = children ? "plain" : "primary";
  const t16 = children ? "small" : "default";
  let t17;
  if ($[45] !== onHide || $[46] !== t15 || $[47] !== t16 || $[48] !== text.close) {
    t17 = <Button as="button" type="button" onClick={onHide} kind={t15} size={t16}>{text.close}</Button>;
    $[45] = onHide;
    $[46] = t15;
    $[47] = t16;
    $[48] = text.close;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  let t18;
  if ($[50] !== children || $[51] !== t14 || $[52] !== t17) {
    t18 = <div className={t14}>{t17}{children}</div>;
    $[50] = children;
    $[51] = t14;
    $[52] = t17;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  let t19;
  if ($[54] !== t12 || $[55] !== t18 || $[56] !== t5) {
    t19 = <div className={styles.container}>{t5}{t12}{t18}</div>;
    $[54] = t12;
    $[55] = t18;
    $[56] = t5;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  return t19;
}
export default ModalContent;